import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { SlTabGroup, SlTab, SlTabPanel } from '@shoelace-style/shoelace/dist/react'
import CustomerwiseSales from './CustomerwiseSales'
import AgingReport from './AgingReport'
import SalesPersonWiseSales from './SalesPersonWiseSales'

function FinanceReports() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [reportType, setReportType] = useState(tab || 'customer');

  useEffect(() => {
    if (tab && tab !== reportType) setReportType(tab);
  }, [tab]);

  const handleTabChange = (e) => {
    const name = e.detail.name;
    setReportType(name);
    navigate(`/home/finance/reports/${name}`, { replace: true });
  };

  return (
    <>
      <h2>Finance Reports</h2>
      <SlTabGroup className='my-2' onSlTabShow={handleTabChange}>
        <SlTab slot="nav" panel="customer" active={reportType === 'customer'}>Customer Reports</SlTab>
        <SlTab slot="nav" panel="aging" active={reportType === 'aging'}>Aging Reports</SlTab>
        <SlTab slot="nav" panel="sales" active={reportType === 'sales'}>Sales Reports</SlTab>
        <SlTabPanel name="customer">{reportType === 'customer' && <CustomerwiseSales />}</SlTabPanel>
        <SlTabPanel name="aging">{reportType === 'aging' && <AgingReport />}</SlTabPanel>
        <SlTabPanel name="sales">{reportType === 'sales' && <SalesPersonWiseSales />}</SlTabPanel>
      </SlTabGroup>
    </>
  );
}
export default FinanceReports